// ReadingProgress — a 2px evergreen bar at the top of the viewport that
// tracks the user's scroll progress through the document. A small delight
// that also helps readers orient in long doc pages.

import { useEffect, useState } from "react";

export default function ReadingProgress() {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const compute = () => {
      const doc = document.documentElement;
      const scrollTop = window.scrollY || doc.scrollTop;
      const height = doc.scrollHeight - doc.clientHeight;
      setProgress(height > 0 ? Math.min(1, scrollTop / height) : 0);
    };
    compute();
    const listener = () => compute();
    window.addEventListener("scroll", listener, { passive: true });
    window.addEventListener("resize", listener);
    return () => {
      window.removeEventListener("scroll", listener);
      window.removeEventListener("resize", listener);
    };
  }, []);

  return (
    <div
      aria-hidden
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        height: 2,
        background: "transparent",
        zIndex: "var(--z-reading-progress)" as unknown as number,
        pointerEvents: "none",
      }}
    >
      <div
        style={{
          width: `${progress * 100}%`,
          height: "100%",
          background:
            "linear-gradient(90deg, var(--accent) 0%, var(--accent-2) 100%)",
          transition: "width 80ms linear",
        }}
      />
    </div>
  );
}
